
































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import {GetPatientInfoById} from '../../api/realTime'
@Component({
    components: {}
})
export default class extends AbpBase {
    @Prop({type:Number}) id:any;
    dataInfo:any = {}
    created(){
        this.getData()
    }
    async getData(){
        let res = await GetPatientInfoById({patientId:this.id})
        this.dataInfo = res.data[0]
    }
}
